import { CheckGreen } from "src/assets";
import { Box, Stack } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { SESSION_KEYS } from "src/consts/session";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import PrimaryButton from "src/components/Shared/PrimaryButton";

const CompatibilitySuccess = () => {
  const { t } = useTranslation();

  const [getSessionStorageItem] = useSessionStorage<string>(
    SESSION_KEYS.REDIRECT_URL,
  );

  const handleSubmit = () => {
    const sessionData = getSessionStorageItem();
    if (sessionData) {
      window.location.href = sessionData;
    }
  };

  return (
    <>
      <Stack gap={5}>
        <Stack gap={2}>
          <Stack>
            <CheckGreen />
          </Stack>

          <Text
            text={t("page.compatibilitySuccess.pageTitle")}
            sx={(theme) => ({
              fontWeight: 500,
              fontSize: "32px",
              color: "#317D5B",
              lineHeight: "40px",
              fontFamily: "officina",
            })}
          />
        </Stack>

        <Text
          text={t("page.compatibilitySuccess.pageSubTitle1")}
          sx={(theme) => ({
            fontSize: "14px",
            lineHeight: "24px",
            fontFamily: "Inter",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Text
          text={
            <Trans
              i18nKey={
                t(
                  "page.compatibilitySuccess.pageSubTitle2",
                ) as "page.compatibilitySuccess.pageSubTitle2"
              }
              t={t}
              components={{ bold: <strong /> }}
            />
          }
          sx={(theme) => ({
            fontSize: "14px",
            lineHeight: "24px",
            fontFamily: "Inter",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Box>
          <PrimaryButton
            onClick={handleSubmit}
            text={t("page.compatibilitySuccess.backBtnText")}
          />
        </Box>
      </Stack>
    </>
  );
};

export default CompatibilitySuccess;
